import _ from 'lodash';
import React from 'react';
import dayjs from 'dayjs';
import DateFnsUtils from '@date-io/date-fns';

// Material UI
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl/FormControl';
import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

// Components
import { FormHelperText, FormInput } from '../_ui/forms.component';
import { FormikFieldLabel } from './formik-field-label.component';
import { FormikFieldCommonProps, useFormikField } from './use-formik-field';
import styled from 'styled-components';

interface IFormikDatePicker extends FormikFieldCommonProps {
  uncontrolled?: boolean;
  placeholder?: string;
  dateFormat: string;
  datetime?: boolean
}

export const FormikDatePicker: React.FC<IFormikDatePicker> = ({
  field,
  fid,
  id,
  label,
  form,
  placeholder,
  dateFormat,
  datetime
}) => {
  const { id: _id, error, touched } = useFormikField({ field, form, fid, id });
  // A blank value parses invalid, which MUI renders as its invalidLabel plus an
  // "Invalid Date Format" error; null renders the empty field a required date needs.
  const parsed = field.value ? dayjs(field.value, dateFormat) : null;

  return (
    <FormControl margin="dense" fullWidth component="div" error={!!error && touched}>
      <FormikFieldLabel label={label} htmlFor={_id} hasError={!!touched && !!error} />
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {
          datetime ?
            <KeyboardDateTimePicker
              id={_id}
              name={field.name}
              error={!!error && !!touched}
              autoOk
              margin="normal"
              value={parsed && parsed.format('YYYY/MM/DD h:mm A')}
              onChange={(value: MaterialUiPickersDate) => {
                form.setFieldValue(field.name, value ? dayjs(value).format(dateFormat) : '');
              }}
              TextFieldComponent={TextFieldComponent} /> :
            <KeyboardDatePicker
              id={_id}
              name={field.name}
              error={!!error && !!touched}
              autoOk
              margin="normal"
              format="yyyy/MM/dd"
              value={parsed && parsed.format('YYYY/MM/DD')}
              onChange={(value: MaterialUiPickersDate) => {
                form.setFieldValue(field.name, value ? dayjs(value).format(dateFormat) : '');
              }}
              TextFieldComponent={TextFieldComponent}
            />
        }
      </MuiPickersUtilsProvider>
      {touched && _.isString(error) && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}


const AdornmentWrapper = styled.div`
  margin-right: 4px;
  padding: 3px 0;

  & > .MuiInputAdornment-root {
    height: auto;
  }

   & > .MuiInputAdornment-positionEnd {
    margin-left: 0;
   }
`;

export const TextFieldComponent = ({ error, helperText, ...props }: any) => {
  return (
    <Box>
      <Box display="flex" justifyContent="center">
        <AdornmentWrapper>
          {props.InputProps.endAdornment}
        </AdornmentWrapper>
        <FormInput {...props} $hasError={!!error} style={{ flexGrow: 1 }} />
      </Box>
      {helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </Box>
  );
};
